<template>
  <div>
    <b-modal
      id="share-modal"
      title="Share Certificate"
      header-bg-variant="success"
      centered
      hide-footer>
      <div>
        <b-form-group label="Email To">
          <b-input
            v-model="mailForm.emailTo"
            size="sm" />
        </b-form-group>
        <b-form-group label="Email Messages">
          <b-textarea
            v-model="mailForm.emailMessage"
            size="sm" />
        </b-form-group>
        <b-form-group label="Attachment">
          <a href="#">{{ attachment }}</a>
        </b-form-group>
        <b-btn
          variant="success"
          size="sm"
          block
          @click="handleSubmit">
          Submit
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ShareCertificateModal',
  props: {
    licensePlate: {
      type: String,
      default: ''
    },
    attachment: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      mailForm: {}
    }
  },
  methods: {
    handleSubmit () {
      const payload = {
        licensePlate: this.licensePlate,
        fileName: this.attachment,
        ...this.mailForm
      }
      this.$emit('submitted', payload)
      this.mailForm.emailTo = ''
      this.mailForm.emailMessage = ''
    }
  }
}
</script>